import { SpyneTrait } from "spyne";

import { SidebarMenuContainerEl } from "components/ui/sidebar/sidebar-menu-container-el";

import sidebarMenuItemTmpl from "../components/ui/sidebar/templates/sidebar-menu-quick-start.tmpl.html";

export class SidebarRenderTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "sidebarRender$";

    super(context, traitPrefix);
  }

  static sidebarRender$GetContainersListArr() {
    return ["render", "behavior", "logic"];
  }

  static sidebarRender$ConformDataForDocsContainers(
    sidebarData = {},
    containersListArr = SidebarRenderTraits.sidebarRender$GetContainersListArr(),
  ) {
    const isContainerFn = (menuData) =>
      menuData?.itemType === "container" &&
      containersListArr.includes(menuData?.container);
    const isInContainerFn = (menuData) =>
      containersListArr.includes(menuData?.container);

    const allDataObj = {
      sidebarData: [],
    };

    const addContainerObj = (o) => {
      return Object.assign({ sidebarData: [] }, o);
    };

    const reduceToContainersList = (dataObj, o) => {
      const { menuData } = o;
      const { container } = menuData;

      const isContainer = isContainerFn(menuData);
      if (isContainer) {
        dataObj[container] = addContainerObj(o);
      } else {
        const arr = dataObj[container]?.sidebarData ?? dataObj.sidebarData;
        arr.push(o);
      }

      return dataObj;
    };

    return sidebarData.reduce(reduceToContainersList, allDataObj);
  }

  static sidebarRender$ContainerSections(
    renderSectionsData = this.props.renderData,
    containerListArr = SidebarRenderTraits.sidebarRender$GetContainersListArr(),
  ) {
    const mapArrToObjProps = (str) => renderSectionsData[str];
    const renderArr = containerListArr.map(mapArrToObjProps);

    const forEachContainerLabel = (str) => {
      const data = renderSectionsData[str];
      //this.appendView(new SidebarMenuContainerEl({data}));

      this.props.el.appendChild(new SidebarMenuContainerEl({ data }).render());
    };

    containerListArr.forEach(forEachContainerLabel);
  }

  static sidebarRender$ReduceToContainers() {
    /***
     * TODO: REDUCE TO NEST THREE CONTAINERS ***CLONE DATA****
     *
     * */
  }

  static sidebarRender$CreateContaner() {
    /**
     *
     * TODO: CREATE DIV ELEMENT FOR CONTAINERS, [RENDER, WIRE, LOGIC]
     *
     * */
  }

  static sidebarRender$HelloWorld(e) {
    return "Hello World";
  }
}
